import * as React from "react";
import { DOCUMENT_STATUS } from "../const";

export const StatusGridTemplate = ({cell}) => {
    return (
        <div style={{ whiteSpace: 'pre-wrap' }}>
            { DOCUMENT_STATUS[cell] }
        </div>
    );
};
